module.exports = __webpack_public_path__ + "img/v1-0.c531ad4a.png";